const sharedPieOptions = {
  resizable: true,
  height: "320px",
  toolbar: {
    enabled: false,
  },
  legend: {
    alignment: "center",
  },
};

export const pieChartRDEPOCOptions = {
  ...sharedPieOptions,
  color: {
    scale: {
      Male: "#2563eb",
      Female: "#be185d",
    },
  },
};

export const pieChartReportOptions = {
  ...sharedPieOptions,
  color: {
    scale: {
      "Police station": "#7c3aed",
      "Health centre": "#0f766e",
    },
  },
};
